import React from 'react';
import styled, { css } from 'styled-components';

import Basic from '@ad-scripts/domain/models/toast/content/basic';
import { Card, Close, Content, Footer } from '@ad-scripts/presentation/components/toasts/toast_content/shared_toast';

export function BasicToast({ toast }) {
  const { message, basicType } = toast.content;

  return (
    <StyledCard $type={basicType} toast={toast} className="toast">
      {message}
    </StyledCard>
  );
}

const StyledCard = styled(Card)`
  line-height: ${p => p.theme.lineHeight.base};
  ${p => p.$type === Basic.Type.ERROR && errorStyles}
  ${p => p.$type === Basic.Type.INFO && infoStyles}
  ${p => p.$type === Basic.Type.SUCCESS && successStyles}
  ${p => p.$type === Basic.Type.WARNING && warningStyles}
`;

const sharedStyles = css`
  z-index: 1000;
  color: ${p => p.theme.colors.black};
  ${Content} {
    margin-bottom: 0;
  }
  ${Close} {
    &:hover {
      color: ${p => p.theme.colors.black};
      opacity: 0.6;
    }
  }
  time {
    color: ${p => p.theme.colors.black};
  }
`;

const errorStyles = css`
  ${sharedStyles}
  border-color: ${p => p.theme.colors.red400};

  ${p => (p.action == null ? hideFooterStyles : null)}
`;
const infoStyles = css``;
const successStyles = css`
  ${sharedStyles}
  border-color: ${p => p.theme.colors.green400};

  ${p => (p.action == null ? hideFooterStyles : null)}
`;
const warningStyles = css`
  ${sharedStyles}
  border-color: ${p => p.theme.colors.yellow400};

  ${p => (p.action == null ? hideFooterStyles : null)}
`;

const hideFooterStyles = css`
  ${Footer} {
    display: none;
  }
`;

export default BasicToast;
